export enum AdServer {
  MOBILE_DE = 'mobile_de',
  AUTOSCOUT24 = 'autoscout24',
  SAUTO = 'sauto',
  AUTOBASAR = 'autobazar_eu',
  TIPCARS = 'tipcars',
  OTOMOTO = 'otomoto_pl',
  BLOCKET = 'blocket',
  HASZNALTAUTO = 'hasznaltauto_hu',
  LA_CENTRALE = 'lacentrale',
  AUTOVIT = 'autovit_ro',
  LUXAUTO = 'luxauto_lu',
  KLEINANZEIGEN = 'kleinanzeigen',
  ENCAR = 'encar_eu',
  TWODEHANDS = '2dehands',
}
